/**
 * 金融機関検索
 */
import Vue from 'vue'
import { DRIVER_ENDPOINT } from "../../../../../../constants/httpConst";

const API_PATH = `${DRIVER_ENDPOINT}/masters/search/addresses/cities`

const master_search_addresses_city = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 金融機関一覧の取得.
     * ドロップダウンで表示可能な内容を返します.
     * @return {Promise<unknown>}
     */
    index ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default master_search_addresses_city
